import './conversions-log.filter.scss'
import {IComponentController, IComponentOptions} from "angular";
import {UserService} from "../../../users_service/service/user.service";
import {ToastNotificationServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {UserView} from "../../../users/model/UserFilter";
import {UserDto} from "../../../users/model/User";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {ConversionLogFilter} from "../../model/ConversionLogFilter";
import {EntitiesSortingOrder} from "../../../opportunities_filter/model/OpportunityFilterUi";
import {ALL_CONVERSION_TYPES, ConversionType} from "../../model/ConversionType";
import {ALL_CAMPAIGN_TYPES, CampaignType} from "../../../campaigns_service/model/CampaignType";
import {ALL_CALCULATORS, CalculatorName} from "../../../calculations/model/Calculator";

export class ConversionsLogFilter implements IComponentController {

    static instance: IComponentOptions = {
        controller: [
            UserServiceName,
            ToastNotificationServiceName,
            ConversionsLogFilter
        ],
        template: require('./conversions-log.filter.html'),
        bindings: {
            onFilterValueChange: '<',
            onSubmit: '<',
            filter: '='
        }
    };

    private onFilterValueChange: (filterVal: ConversionLogFilter) => void;
    private onSubmit: (filterVal: ConversionLogFilter) => void;
    private filter: ConversionLogFilter;
    private now: Date;
    private ALL_CONVERSION_TYPES: ConversionType[];
    private ALL_CAMPAIGN_TYPES: CampaignType[];
    private ALL_CALCULATOR_NAMES: CalculatorName[];

    constructor(private userService: UserService,
                private toastNotificationService: ToastNotificationService) {
        this.now = new Date(Date.now());
        this.ALL_CONVERSION_TYPES = ALL_CONVERSION_TYPES();
        this.ALL_CAMPAIGN_TYPES = ALL_CAMPAIGN_TYPES();
        this.ALL_CALCULATOR_NAMES = ALL_CALCULATORS;
    }

    $onInit = () => {
        this.filter = this.initFilter();
        this.handleInvalidInitialDates();
        this.onSubmit(this.filter);
    };

    private initFilter() {
        return this.filter || this.initDefaultFilter();
    }

    private initDefaultFilter(): ConversionLogFilter {
        return {
            startDate: undefined,
            endDate: new Date(Date.now()),
            customerName: undefined,
            employees: [],
            sortingOrder: EntitiesSortingOrder.NEW_FIRST,
            branchNames: [],
            brandName: [],
            conversionTypes: [],
            calculatorNames: [],
            campaignTypes: []
        };
    }

    private handleInvalidInitialDates() {
        if (!this.filter.endDate.isValid()) {
            this.filter.endDate = this.now;
        }
    }

    fetchEmployees = (query: string): angular.IPromise<UserDto[]> => {
        return this.userService.queryEmployee(this.getUserFilter(query))
            .then((resp) => {
                if (resp.status == 200) {
                    return resp.data;
                } else {
                    this.toastNotificationService.generateErrorMessage('Failed to fetch users')
                }
            })
    };

    private getUserFilter(query: string) {
        return {
            branchesIds: this.filter.branchNames,
            showDeleted: false,
            showDisabled: true,
            userIds: [],
            query: query,
            view: UserView.AUTOCOMPLETE
        };
    }

    onEmployeeFilterValueChange = (employeeIds: number[]) => {
        this.filter.employees = employeeIds;
        if (employeeIds && employeeIds.length) {
            this.submitFilterValueChanges(this.filter);
        }
    };

    submitFilterValueChanges = (filterValue: ConversionLogFilter): void => {
        this.onFilterValueChange(filterValue);
    };

    checkForSubmit = ($event) => {
        if ($event.which === 13) {
            this.submitFilterValueChanges(this.filter);
        }
    };

    toggleConversionType = (type: ConversionType) => {
        if (this.filter.conversionTypes.includes(type)) {
            this.filter.conversionTypes = this.filter.conversionTypes.filter(t => t != type);
        } else {
            this.filter.conversionTypes.push(type);
        }
    }

}